import getId from '@/utils/getIdFromLink'

export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => {
  if (state.retrieved) {
    if (state.retrieved.priceUserData.length > 0) {
      state.retrieved.customPrices = state.retrieved.priceUserData.map(entry => {
        return {
          priceBrutto: entry.priceBrutto,
          idUserData: getId(entry.idUserData['@id'])
        }
      })
    }
    if (typeof state.retrieved.vatRate === 'object') state.retrieved.vatRate = state.retrieved.vatRate['@id']
    if (typeof state.retrieved.category === 'object') state.retrieved.category = state.retrieved.category['@id']
    if (state.retrieved.priceGroup && state.retrieved.priceGroup['@id']) state.retrieved.priceGroup = state.retrieved.priceGroup['@id']
    if (typeof state.retrieved.measure === 'object') state.retrieved.measure = state.retrieved.measure['@id']
    if (state.retrieved.itemTags) {
      state.retrieved.itemTags = state.retrieved.itemTags.map(entry => {
        if (entry.tag && entry.tag.tag) {
          return { '@id': entry['@id'], value: entry.tag['@id'], text: entry.tag.tag }
        } else {
          return { '@id': entry['@id'], value: entry.value, text: entry.text }
        }
      })
    }
  }

  return state.retrieved
}
export const updated = state => state.updated
export const violations = state => state.violations
